export default function parseCSV(csv: string) : any { 
    const rows : string[] = csv.split(/\r?\n/) 
    const thread = rows[0].split(";")
    const titleIndex = thread.findIndex(t => t === "Title")
    const contentIndex = thread.findIndex(t => t === "Description")
    const descriptionIndex = thread.findIndex(t => t === "Text")
    const thumbnailIndex = thread.findIndex(t => t === "Photo")
    const categories: any[] = [
        {
            name: "Category",
            index: 4,
            items: []
        }, 
    ]
    thread.forEach((cell: string, i) => {
        if(cell.indexOf(`Characteristics:`) >= 0){
            categories.push({
                name: cell.replace(`Characteristics:`, "").replaceAll('"', ""),
                index: i,
                items: []
            })
        }
    }) 
    const data = rows.splice(1,)
        .filter(row => !!row)
        .map(row => {
            const dt = row.split(";")
            categories.forEach(cat => {
                if(!!dt[cat.index] && !cat.items.includes(dt[cat.index].replaceAll('"', ""))) {
                    cat.items.push(dt[cat.index].replaceAll('"', ""))
                }
            })
            return dt.map(d => d.replaceAll('"', ""))
        })
    return { thread, data, categories, titleIndex, contentIndex, descriptionIndex, thumbnailIndex, }
}